<template>
  <div class="bulktrashsettings" v-if="user.isAdmin == true">
    <div class="container-fluid">
      <div
        class="
          container-fluid
          p-3
          mb-3
          bg-secondary
          text-white text-center
          rounded
        "
      >
        <h5 class="card-title font-weight-bold">Bulk Trash Settings</h5>
      </div>

      <div class="mb-4 text-right">
        <a
          class="btn btn-primary"
          href="#"
          @click="SaveSettings"
          data-toggle="tooltip"
          data-placement="bottom"
          title="Save Changes"
        >
          <i class="fas fa-cloud-upload-alt mr-1"></i>
          Save Changes
        </a>
      </div>
      <div class="row" v-if="user.isManager == true">
        <div class="col-sm-6 mt-4" style="margin-bottom: 20px">
          <div class="card">
            <div id="v-for-object" class="card-body">
              <h5 class="card-title">Modify User Account Privileges</h5>
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"
                      >Email</span
                    >
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="email@website.com"
                    aria-label="user_email"
                    aria-describedby="basic-addon1"
                    v-model.lazy="emailSearch"
                  />
                </div>
                <div>
                  <div>
                    <!-- Example split danger button -->

                    <div class="btn-group mb-2 mt-2">
                      <button
                        type="button"
                        class="
                          btn btn-outline-info
                          dropdown-toggle dropdown-toggle-split
                          no-default-icon
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Account Actions
                        <i class="fas fa-chevron-circle-down ml-2"></i>
                      </button>
                      <div class="dropdown-menu">
                        <a
                          class="dropdown-item clickable"
                          @click="makeAdmin(emailSearch)"
                          ><i class="fas fa-user-shield mr-2"></i>Make Admin</a
                        >
                        <a
                          class="dropdown-item clickable"
                          @click="removeAdmin(emailSearch)"
                          ><i class="fas fa-user-lock mr-2"></i>Remove Admin
                        </a>
                        <div class="dropdown-divider"></div>
                        <a
                          class="dropdown-item clickable"
                          @click="resetPassword(emailSearch)"
                          ><i class="fas fa-users mr-2"></i>Reset Password
                        </a>
                        <!--
                        <a
                          class="dropdown-item clickable"
                          @click="makeManager(emailSearch)"
                          ><i class="fas fa-users mr-2"></i> Make Manager
                        </a>
                        <a
                          class="dropdown-item clickable"
                          @click="removeManager(emailSearch)"
                          ><i class="fas fa-users-slash mr-2"></i> Remove
                          Manager</a>-->
                      </div>
                    </div>
                    <a
                      class="btn btn-secondary ml-2"
                      href="#"
                      @click="createUser(emailSearch)"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Save Changes"
                    > <i class="fas fa-users mr-2"></i>Create User
                    </a>
                  </div>
                  <span
                    class="mt-6"
                    v-bind:class="[successSearch ? 'success' : '', 'error']"
                    >{{ privilegesMsg }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mt-4" style="margin-bottom: 20px">
          <div class="card">
            <div id="v-for-object" class="card-body">
              <h5 class="card-title">Bulk Requests Options</h5>
              <div class="form-group">
                <div class="input-group mb-4 mt-5" style="padding-bottom: 14px">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="button-addon1"
                      >Requests Auto-Delete</span
                    >
                  </div>
                  <input
                    type="text"
                    v-model="bulksettings.bulk_request_duration"
                    placeholder="New bulk type"
                    class="form-control"
                    aria-label="Example text with button addon"
                    aria-describedby="button-addon1"
                  />

                  <span
                    class="input-group-text"
                    id="button-addon1"
                    style="
                      border-top-left-radius: 0px;
                      border-bottom-left-radius: 0px;
                    "
                    >Days</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <div class="card">
            <div id="v-for-object" class="card-body">
              <h5 class="card-title">Bulk Trash Types</h5>
              <p class="card-text">Manage available bulk trash types.</p>
              <div
                v-for="(type, itemObjKey) in sortBulkTypes(bulkTypes)"
                :key="type.id"
              >
                <BulkTypeLabelEditor
                  :type="returnTypeName(type.name, type.id)"
                  :msg="returnTypeMessage(type.message, type.id)"
                  :pickup="returnTypePickup(type.pickup, type.id)"
                  :id="itemObjKey + 1"
                  :change="onChangeBulkTypes(type.id)"
                  :deleteType="deleteBulkType(type.id)"
                  :item="type"
                />
              </div>
              <a
                class="btn btn-primary"
                href="#"
                @click="addBulkType"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Add Bulk Type"
                style="float: right"
                v-if="bulksettings.maximum_total_bulk_types > bulkTypes.length"
              >
                <i class="fa fa-plus-circle mr-1"></i>
                Add Bulk Type
              </a>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="card">
            <div id="v-for-object" class="card-body" style="margin-bottom: 9vh">
              <h5 class="card-title">Resident View</h5>
              <p class="card-text">
                Choose a bulk type to preview what residents see when they
                select that same bulk type.
              </p>
              <div class="col-md-6">
                <p class="mb-1 text-muted">Bulk Type</p>
                <select
                  v-model="bulksettings.req_preview_type"
                  class="form-control mb-4"
                  required
                >
                  <option
                    v-for="type in sortBulkTypes(
                      bulkTypes,
                      true,
                      bulksettingsUpdates
                    )"
                    :value="type.name"
                    :key="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
              </div>

              <div
                v-for="type in sortBulkTypes(
                  bulkTypes,
                  true,
                  bulksettingsUpdates
                )"
                :key="type.id"
              >
                <BulkTypeErrorsCard
                  :id="type.id"
                  :pickup="type.pickup"
                  :type="type.name"
                  :msg="type.message"
                  v-if="bulksettings.req_preview_type === type.name"
                />
                <BulkTypeCard
                  :id="type.id"
                  :pickup="type.pickup"
                  :type="returnTypeName(type.name, type.id)"
                  :msg="type.message"
                  v-if="bulksettings.req_preview_type === type.name"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-4">
          <div class="card">
            <div id="v-for-object" class="card-body">
              <h5 class="card-title">Trash Type Messages</h5>
              <p class="card-text">
                Create unique messages for each bulk trash type.
              </p>
              <div v-for="type in sortBulkTypes(bulkTypes)" :key="type.id">
                <BulkTypeDetailsEditor
                  :id="type.id"
                  :onPickupChange="updateBulkTypePickup(type.id)"
                  :pickup="returnTypePickup(type.pickup, type.id)"
                  :type="returnTypeName(type.name, type.id)"
                  :onMessageChange="updateBulkTypeMessage(type.id)"
                  :msg="returnTypeMessage(type.message, type.id)"
                  :item="type"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateUser ref="userModal" :onCreate="createUserSuccess" />
    <div class="mt-2 text-right">
      <a
        class="btn btn-primary mr-3"
        href="#"
        @click="SaveSettings"
        data-toggle="tooltip"
        data-placement="bottom"
        title="Save Changes"
      >
        <i class="fas fa-cloud-upload-alt mr-1"></i>
        Save Changes
      </a>
    </div>
  </div>
</template>

<script>
import { fb, db, auth } from "../firebase";
import Vue from "vue";
import { VueEditor } from "vue2-editor";
import { mapState, mapGetters } from "vuex";
import BulkTypeCard from "../components/design/BulkTypeCard.vue";
import BulkTypeErrorsCard from "../components/design/BulkTypeErrorsCard.vue";
import BulkTypeDetailsEditor from "../components/design/BulkTypeDetailsEditor.vue";
import BulkTypeLabelEditor from "../components/design/BulkTypeLabelEditor.vue";
import CreateUser from "../components/CreateUser.vue";
import { dbSchema } from "../store";

export default {
  name: "BulkTrashSettings",
  components: {
    VueEditor,
    BulkTypeCard,
    BulkTypeDetailsEditor,
    BulkTypeLabelEditor,
    CreateUser,
    BulkTypeErrorsCard,
  },
  computed: {
    ...mapState(["bulksettings", "bulkTypes"]),
    ...mapGetters({
      user: "user",
    }),
  },
  props: {},
  data() {
    return {
      successSearch: false,
      emailSearch: "",
      privilegesMsg: "",
      bulksettingsUpdates: {},
      enforceNewAccounts: true,
    };
  },

  methods: {
    deleteBulkType(id) {
      return async (event) => {
        var types = await db.collection(dbSchema.bulkTypes).get();
        types.docs.forEach((doc) => {
          if (id == doc.id) {
            var { name } = doc.data();
            doc.ref.delete();
            if (this.bulksettings.req_preview_type == name || name == "")
              this.bulksettings.req_preview_type = "";

            console.log(this.bulksettingsUpdates[id]);
            console.log(this.bulksettingsUpdates);
            delete this.bulksettingsUpdates[id];
          }
        });

        Toast.fire({
          type: "success",
          title: "Bulk Type Deleted Successfully",
        });
      };
    },
    sortBulkTypes(bulkTypes, dropEmpty = false) {
      const emptyData = [];
      var types = bulkTypes.filter((item) => {
        if (item.name == "" || item.name == null) {
          emptyData.push(item);
          return false;
        }
        return true;
      });

      types = types.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();

        if (textA < textB) return -1;

        if (textA > textB) {
          return 1;
        }

        return 0;
      });

      if (!dropEmpty) return types.concat(emptyData);
      else {
        var updateObject = { ...this.bulksettingsUpdates };
        var outputObject = [];

        emptyData.forEach((item) => {
          var obj = updateObject[item.id];

          console.log(obj);
          if (obj != undefined) {
            obj.id = item.id;
            outputObject.push(obj);
          }

          return true;
        });

        return types.concat(outputObject);
      }
    },
    onChangeBulkTypes(id) {
      const updatebulkType = ((val) => {
        const bulkVal = this.bulksettingsUpdates[id];
        if (!bulkVal) {
          var obj = { ...this.bulksettingsUpdates };
          obj[id] = {
            name: val,
          };
          this.bulksettingsUpdates = obj;
        } else this.bulksettingsUpdates[id].name = val;
      }).bind(this);

      return (e) => {
        const resultVal = e.target.value;
        updatebulkType(resultVal);
      };
    },
    returnTypeName(type, id) {
      const obj = this.bulksettingsUpdates[id];
      return obj && obj.name ? obj.name : type;
    },
    returnTypePickup(pickup, id) {
      const obj = this.bulksettingsUpdates[id];
      return obj && obj.pickup ? obj.pickup : pickup;
    },
    returnTypeMessage(message, id) {
      const obj = this.bulksettingsUpdates[id];
      return obj && obj.message ? obj.message : message;
    },
    addBulkType() {
      db.collection(dbSchema.bulkTypes).add({
        name: "",
        message: "",
        pickup: "",
      });
    },
    async SaveSettings() {
      var typesRef = await db.collection(dbSchema.bulkTypes).get();

      var objects = typesRef.docs.forEach(async (doc) => {
        const mergeObject = { ...this.bulksettingsUpdates[doc.id] };
        await doc.ref.set(mergeObject, { merge: true });
      });

      await db
        .collection(dbSchema.settings)
        .doc(dbSchema.settingsDocId)
        .set(
          { bulk_request_duration: this.bulksettings.bulk_request_duration },
          { merge: true }
        );
      Toast.fire({
        type: "success",
        title: "Bulk Trash Settings Saved",
      });
    },
    updateBulkTypeMessage(id) {
      const updatebulkType = ((val) => {
        const bulkVal = this.bulksettingsUpdates[id];
        if (!bulkVal) {
          var obj = { ...this.bulksettingsUpdates };
          obj[id] = {
            message: val,
          };

          this.bulksettingsUpdates = obj;
        } else this.bulksettingsUpdates[id].message = val;
        this.$forceUpdate();
      }).bind(this);

      return (e) => {
        const resultVal = e.target.value;
        updatebulkType(resultVal);
      };
    },
    updateBulkTypePickup(id) {
      const updatebulkType = ((val) => {
        const bulkVal = this.bulksettingsUpdates[id];
        if (!bulkVal) {
          var obj = { ...this.bulksettingsUpdates };
          obj[id] = {
            pickup: val,
          };
          this.bulksettingsUpdates = obj;
        } else this.bulksettingsUpdates[id].pickup = val;

        this.$forceUpdate();
      }).bind(this);

      return (e) => {
        const resultVal = e.target.value;
        updatebulkType(resultVal);
      };
    },
    validateEmail(email) {
      const re = /^[^@\s]+@[^@\s\.]+\.[^@\.\s]+$/;
      return re.test(String(email).toLowerCase());
    },
    makeAdmin(email) {
      if (!this.validateEmail(email)) {
        this.privilegesMsg = "Invalid Email Address";
        return;
      } else {
        this.privilegesMsg = "";
      }

      var successCall = () => {
        this.privilegesMsg = `Admin privileges added to '${email}'`;
        this.successSearch = true;
      };

      successCall = successCall.bind(this);

      var failCall = () => {
        this.privilegesMsg = `No account for the login: '${email}' exists`;
        this.successSearch = false;
      };

      var nonExist = true;

      db.collection(dbSchema.users)
        .where("email", "==", email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(function (doc) {
            const { admin } = doc.data();
            doc.ref.update({ admin: true });
            nonExist = false;
          });
        })
        .finally(() => {
          if (nonExist && !this.enforceNewAccounts) {
            db.collection(dbSchema.users).add({
              email: email,
              admin: true,
            });
            successCall();
          } else if (!nonExist && this.enforceNewAccounts) {
            successCall();
          } else {
            failCall();
          }
        });
    },
    removeAdmin(email) {
      if (!this.validateEmail(email)) {
        this.privilegesMsg = "Invalid Email Address";
        return;
      } else {
        this.privilegesMsg = "";
      }

      if (email == this.user.email) {
        this.privilegesMsg = "You cannot remove your own admin privileges";
        this.successSearch = false;
        return;
      }

      var successCall = () => {
        this.privilegesMsg = `Admin privileges removed from '${email}'`;
        this.successSearch = true;
      };

      successCall = successCall.bind(this);

      var failCall = () => {
        this.privilegesMsg = `No account for the login: '${email}' exists`;
        this.successSearch = false;
      };

      failCall = failCall.bind(this);

      var nonExist = true;

      db.collection(dbSchema.users)
        .where("email", "==", email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(function (doc) {
            const { admin } = doc.data();
            doc.ref.update({ admin: false });
            nonExist = false;
          });
        })
        .finally(() => {
          if (nonExist && !this.enforceNewAccounts) {
            successCall();
          } else if (!nonExist && this.enforceNewAccounts) {
            successCall();
          } else {
            failCall();
          }
        });
    },
    makeManager(email) {
      if (!this.validateEmail(email)) {
        this.privilegesMsg = "Invalid Email Address";
        return;
      } else {
        this.privilegesMsg = "";
      }

      var successCall = () => {
        this.privilegesMsg = `Manager privileges added to '${email}'`;
        this.successSearch = true;
      };

      successCall = successCall.bind(this);

      var failCall = () => {
        this.privilegesMsg = `No account for the login: '${email}' exists`;
        this.successSearch = false;
      };

      failCall = failCall.bind(this);

      var nonExist = true;

      db.collection(dbSchema.users)
        .where("email", "==", email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(function (doc) {
            doc.ref.update({ manager: true });
            nonExist = false;
          });
        })
        .finally(() => {
          if (nonExist && !this.enforceNewAccounts) {
            db.collection(dbSchema.users).add({
              email: email,
              manager: true,
            });
            successCall();
          } else if (!nonExist && this.enforceNewAccounts) {
            successCall();
          } else {
            failCall();
          }
        });
    },
    removeManager(email) {
      if (!this.validateEmail(email)) {
        this.privilegesMsg = "Invalid Email Address";
        return;
      } else {
        this.privilegesMsg = "";
      }

      if (email == this.user.email) {
        this.privilegesMsg =
          "Please contact support in order to remove your own management privileges";
        this.successSearch = false;
        return;
      }

      var successCall = () => {
        this.privilegesMsg = `Manager privileges removed from '${email}'`;
        this.successSearch = true;
      };

      successCall = successCall.bind(this);

      var failCall = () => {
        this.privilegesMsg = `No account for the login: '${email}' exists`;
        this.successSearch = false;
      };

      failCall = failCall.bind(this);

      var nonExist = true;
      db.collection(dbSchema.users)
        .where("email", "==", email)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(function (doc) {
            doc.ref.update({ manager: false });
            nonExist = false;
          });
        })
        .finally(() => {
          if (nonExist && !this.enforceNewAccounts) {
            successCall();
          } else if (!nonExist && this.enforceNewAccounts) {
            successCall();
          } else {
            failCall();
          }
        });
    },
    resetPassword(email) {
      if (!this.validateEmail(email)) {
        this.privilegesMsg = "Invalid Email Address";
        this.successSearch = false;
        return;
      }

      auth
        .sendPasswordResetEmail(email)
        .then((() => {}).bind(this))
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
        });

      this.privilegesMsg = `if an account for '${email}' exists, a password reset email has been sent.`;
      this.successSearch = true;
    },
    createUser(email) {
      this.$refs.userModal.setEmail(email);
      console.log($("#create_login").modal);
      $("#create_login").modal("show");
      this.privilegesMsg = "";
      this.successSearch = false;
    },
    createUserSuccess(email) {
      this.privilegesMsg = `'${email}' user account created successfully`;
      this.successSearch = true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
